
  import { Vue, Component, Prop } from "vue-property-decorator";
  import RouteParams from "@/entities/RouteParams";
  import CardTitleContainer from "@/components/card/CardTitleContainer.vue";

  @Component({
    components: { CardTitleContainer }
  })
  export default class EmployeeCardUserName extends Vue {
    @Prop({ type: Object, required: true }) readonly employeePageRouteParams!: RouteParams<{ id: string }>;
    @Prop({ type: String, required: true }) readonly givenName!: string;
    @Prop({ type: String, required: true }) readonly familyName!: string;
  }
